import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toMbps',
})
export class ToMbpsPipe implements PipeTransform {
  transform(bytesPerSecond: number | undefined): number {
    return toMbps(bytesPerSecond);
  }
}

export function toMbps(bytesPerSecond: number | undefined): number {
  if (!bytesPerSecond || bytesPerSecond <= 0) return 0;
  const mbps = bytesPerSecond / 1_000_000;
  return parseFloat(mbps.toFixed(2));
}
